import * as Yup from 'yup';

const directorBookingSchema = Yup.object().shape(
  {
    id: Yup.string().required("Поле обов'язкове"),
    bookingStatus: Yup.number().required("Поле обов'язкове"),
    comment: Yup.string()
      .nullable()
      .trim()
      .when(['bookingStatus'], {
        is: (bookingStatus: number) => bookingStatus === 4,
        then: Yup.string().nullable().required("Поле обов'язкове"),
      }),
  },
  [['bookingStatus', 'comment']],
);

export default directorBookingSchema;
